import { MapRowValue } from '@sg/backend/src/lib/db/getMapOr404'
import { Component, DEV, onMount } from 'solid-js'
import { createMutable } from 'solid-js/store'
import toast from 'solid-toast'
import bindViewCtxToWindowV2 from '../lib/bindViewCtxToWindowV2'
import bindEngineToComponentV2 from '../lib/canvas/bindEngineToComponentV2'
import createEngineForMapEditor from '../lib/core/engine/createEngineForMapEditor'
import { Engine } from '../lib/core/engine/Engine.type'
import syncEngineWithPropsRow from '../lib/core/engine/syncEngineWithPropsRow'
import isEntityWater from '../lib/core/entity/isEntityWater'
import { SelectedToolId } from '../lib/core/map_editor/SelectedToolId.enum'
import coord from '../lib/core/tile_position_xy/coord'
import { deepClone } from '../lib/deep_clone'
import isNil from '../lib/ldsh/isNil'
import isNotNil from '../lib/ldsh/isNotNil'
import bindCameraToUserPreferences from '../lib/three/camera/bindCameraToUserPreferences'
import createMainCamera from '../lib/three/fn/createMainCamera'
import createMountedMainCanvasElement from '../lib/three/fn/createMountedMainCanvasElement'
import createMountedMainRenderer from '../lib/three/fn/createMountedMainRenderer'
import { setEngineThreeMainCamera } from '../lib/three/fn/getSetEngineThreeMainCamera'
import { setEngineThreeMainRenderer } from '../lib/three/fn/getSetEngineThreeMainRenderer'
import { setEngineToast } from '../lib/three/fn/getSetEngineToast'
import onMountStartCameraNearLastAction from '../lib/three/fn/onMountStartCameraNearLastAction'
import MiniMap1Px from '../lib/three/MiniMap/MiniMap1Px.component'
import MiniMapContainer from '../lib/three/MiniMap/MiniMapContainer.component'
import createSetEngineAuthPlayerIdFromAuthProfileSignalEffect from '../rx/effect/createSetEngineAuthPlayerIdFromAuthProfileSignalEffect'
import { getAuthProfile } from '../rx/shared/profile/createAuthProfileSignal'
import { useSelectedPositionListSignal } from '../rx/signal/useSelectedPositionListSignal'
import { useSelectedToolSignal } from '../rx/signal/useSelectedToolSignal'
import createMapEditThreeJsCanvasDebug from './createMapEditThreeJsCanvasDebug'
import EngineContext from './EngineContext'
import GameActionLogListModal from './GameActionLogListModal'
import MapEditorToolbar from './Hud/MapEditorToolbar'

interface Props {
  // session: BackendSessionPayload,
  row: MapRowValue,
}

// const componentStateType = StateType.Map

const MapEditThreeJsCanvas: Component<Props> = (props) => {
  const engine: Engine = createMutable<Engine>(createEngineForMapEditor())

  onMount(() => {
  // eslint-disable-next-line solid/reactivity
    const { row } = props

    row.data.ents = row.data.ents.map((ent0) => {
      const ent1 = deepClone(ent0)
      if (isNotNil(ent1.elevation)) {
        if (isNil(ent1.floor_e)) {
          ent1.floor_e = ent1.elevation
          delete ent1.elevation
        }
      }
      if (isNil(ent1.water_e)) {
        if (isEntityWater(ent1)) {
          ent1.water_e = 0
        } else if ('water_e' in ent1) {
          // ent1.water_e = ELEVATION_ABSOLUTE_MIN
        }
      }

      delete ent1.elevation

      // if (isEntityWater(ent1)) {
      //   const current : CurrentEDCS = {
      //     s: 1,
      //     edc: 0
      //   }
      //   ent1.current = current
      // }

      return ent1
    })

    syncEngineWithPropsRow(engine, row)

    if (DEV) {
      createMapEditThreeJsCanvasDebug(engine)
    }
  })

  createSetEngineAuthPlayerIdFromAuthProfileSignalEffect(engine, getAuthProfile)

  // createCenterPanOnMount(engine)

  // addCursorCanvas(engine)

  // registerTouchEventsV2(engine)

  // registerServerSentEvents(engine)
  // createRedirectIfWrongStateTypeEffect(componentStateType, () => engine.state.type, () => engine.state.online?.id)

  setEngineToast(engine, toast)

  const canvasElem = createMountedMainCanvasElement()
  const renderer = createMountedMainRenderer(canvasElem)
  setEngineThreeMainRenderer(engine, renderer)
  const camera = createMainCamera(canvasElem)
  setEngineThreeMainCamera(engine, camera)

  bindViewCtxToWindowV2(engine, canvasElem)
  bindEngineToComponentV2(engine, canvasElem)
  bindCameraToUserPreferences(engine)

  onMountStartCameraNearLastAction(engine)

  onMount(() => {
    const [,setSelectedTool] = useSelectedToolSignal(engine)
    const [,setSelectedPositionList] = useSelectedPositionListSignal(engine)
    //     // engine.selectedPosition = { x: 13, y: 9 }
    //     // calculateSelectedPositionEnts(engine)
    //     // setSelectedTool(SelectedToolId.File)
    setSelectedTool(SelectedToolId.Inspect)
    // setSelectedTool(SelectedToolId.Tools)
    // setSelectedTool(SelectedToolId.Paint)
    // setSelectedTool(SelectedToolId.Players)
    // setSelectedTool(SelectedToolId.Elevation)
    setSelectedPositionList([
      coord(4,4),
      coord(5,5),
      coord(4,5),
      coord(5,4),
    ])
    //     // engine.selectedTool = SelectedToolId.Erase
    //     engine.viewCtx.zoom = 200
    //     engine.viewCtx.tile_size = calculateTileSize(engine.viewCtx)
    //     calculateMapWidthHeightPxTileSize(engine)
    //     centerPan(engine)
  })

  return <EngineContext.Provider value={engine}>
    <MiniMapContainer>
      <MiniMap1Px state={engine.state} size={8} />
    </MiniMapContainer>
    <div id="gpc">
      <div id="gvp" ref={(ref: HTMLElement) => {
        // console.log('ref', ref)
        if (ref) {
          // registerTouchEventsV2(engine, ref)
          // registerMouseMoveEvent(engine, ref)
        }
      }}>
        {canvasElem}
      </div>
    </div>
    <MapEditorToolbar />
    <GameActionLogListModal />
  </EngineContext.Provider>
}

export default MapEditThreeJsCanvas
